import React from 'react';
import { Link } from 'react-router-dom';

const LoginLayoutB = ({
  email, setEmail,
  password, setPassword,
  error, loading,
  onSubmit
}) => {
  return (
    <div className="aut-login-b-container">
      <div className="aut-login-b-brand-panel">
        <div className="aut-login-b-brand-content">
          <h2 className="aut-login-b-brand-title">TestApp</h2>
          <p className="aut-login-b-brand-tagline">Your project management solution</p>
        </div>
      </div>

      <div className="aut-login-b-form-panel">
        <div className="aut-login-b-form-wrapper">
          <h1 className="aut-login-b-title">Account Access</h1>
          <p className="aut-login-b-subtitle">Authenticate to continue</p>

          {error && (
            <div className="aut-login-b-error">{error}</div>
          )}

          <form className="aut-login-b-form" onSubmit={onSubmit}>
            <div className="aut-login-b-field">
              <label className="aut-login-b-label" htmlFor="user-email">Email</label>
              <input
                id="user-email"
                name="userEmail"
                type="email"
                className="aut-login-b-input"
                placeholder="name@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                data-field="identity"
              />
            </div>

            <div className="aut-login-b-field">
              <label className="aut-login-b-label" htmlFor="user-password">Password</label>
              <input
                id="user-password"
                name="userPassword"
                type="password"
                className="aut-login-b-input"
                placeholder="Your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                data-field="credential"
              />
            </div>

            <button
              type="submit"
              className="aut-login-b-submit"
              disabled={loading}
              data-action="authenticate"
            >
              {loading ? 'Authenticating...' : 'Continue'}
            </button>
          </form>

          <div className="aut-login-b-footer">
            First time here?{' '}
            <Link to="/register" className="aut-login-b-link">
              Create account
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginLayoutB;
